module.exports = __webpack_public_path__ + "static/patagonia_395x285-4c14d23eeed5b5ed7b5fded49a785536.webp";